import { Modal } from 'semantic-ui-react';
import { TaskCreationSchemaType, TaskType, TaskUpdateSchemaType } from '../../../../schemas/task.schemas';
import { UserType } from '../../../../types/user.type';
import TaskForm from '../taskForm';

type CreateTaskModalPropsType = {
    task?: Partial<TaskType>;
    open: boolean;
    onCancel: () => void;
    onSave: (data: TaskCreationSchemaType & TaskUpdateSchemaType) => void;
    users: UserType[];
};

function TaskModal({ open, onCancel, onSave, users, task }: CreateTaskModalPropsType) {
    return (
        <Modal size="small" open={open} onClose={onCancel}>
            <Modal.Header>Create Task</Modal.Header>
            <Modal.Content>
                <TaskForm users={users} onSave={onSave} onCancel={onCancel} task={task} />
            </Modal.Content>
        </Modal>
    );
}

export default TaskModal;
